import React from 'react';
import { Box } from '@mui/material';
import TransferMatchingConfigForm from './components/TransferMatchingConfigForm';

const TransferMatchingConfigCreatePage: React.FC = () => {
  return (
    <Box p={3}>
      <TransferMatchingConfigForm />
    </Box>
  );
};

export default TransferMatchingConfigCreatePage;